import React, { useState, useEffect, useContext } from "react";
import "./EffectInfo.css";
import {
  getEffects,
  EffectById,
} from "../../../../../utils/apis/effects/Effects";
import { Context } from "../../../../../utils/context";
import { IDS } from "../../../../../utils/common";
import { useParams } from "react-router-dom";
import ProductSection from "../product_section/ProductSection";

export default function EffectInfo({ effectId }) {
  // const { id } = useParams();

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [effectinfo, setEffectInfo] = useState({});

  const getEffectInfo = async () => {
    const res = await EffectById(effectId);
    if (res?.success) {
      setEffectInfo(res?.data || {});
    }
  };

  useEffect(() => {
    if (effectId) getEffectInfo();
  }, [effectId]);

  return (
    <>
      <div className="effect-info-section">
        <div className="container">
          <div className="info-wrapper">
            {" "}
            <div className="left col-6">
              {/* <img alt="not" src="/assets/images/newhome/about2.png" /> */}

              <img src={IDS?.IMG_URL + effectinfo?.image} />
              {/* <h3 className="img-title">Flame Effects</h3> */}

              <h3 className="img-title">{effectinfo?.name}</h3>
            </div>
            <div className="right col-6">
              <p className="desc">
                {/* Flame Effect is a visual style that uses fire-like elements—glow,
    heat, and flickering light—to create a sense of energy, power, and
    intensity. Flame Effect is a visual style that uses fire-like
    elements—glow, heat, and flickering light—to create a sense of
    energy, power, and intensity. Flame Effect is a visual style that
    uses fire-like elements—glow, heat, and flickering light—to create
    a sense of energy, power, and intensity. Flame Effect is a visual
    style that uses fire-like elements—glow, heat, and flickering
    light—to create a sense of energy, power, and intensity. */}

                {htmlToReactParser.parse(effectinfo?.sub_title)}
              </p>
              <ul>
                <h5>It is often used to:</h5>
                {/* <li>Highlight important elements </li>
    <li>Add dramatic and bold appeal</li>
    <li>Create a dynamic, eye-catching look </li> */}
                <p>{htmlToReactParser.parse(effectinfo?.description)}</p>
              </ul>
            </div>
          </div>
          <div className="perfect-div">
            <p className="title"> Perfect for:</p>
            <p className="info">
              {/* designs that need to feel strong, vibrant, and attention grabbing.
    designs that need to feel strong, vibrant, and attention grabbing.
    designs that need to feel strong, vibrant, and attention grabbing. */}
              {htmlToReactParser.parse(effectinfo?.perfect_for)}
            </p>
          </div>
        </div>
      </div>
      <ProductSection effectId={effectId} />
    </>
  );
}
